import { NgModule } from '@angular/core';

import { LegalFrameworkRoutingModule, routedComponents } from './legal-framework-routing.module';
import { SharedModule } from '../shared/shared.module';

import {
  ScheduleModule,
  DialogModule,
  CalendarModule,
  CheckboxModule,
  InputTextModule,
  DropdownModule,
  MultiSelectModule
} from 'primeng/primeng';

@NgModule({
  imports: [
    LegalFrameworkRoutingModule,
    SharedModule,
    DialogModule,
    CalendarModule,
    DropdownModule,
    MultiSelectModule,
    ScheduleModule,
  ],
  declarations: [
    routedComponents
  ],
  providers:[],
})
export class LegalFrameworkModule { }



// WEBPACK FOOTER //
// ./src/app/legal-framework/legal-framework.module.ts